import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { triggerStopLossReport } from "../../../utils/apiUtils";
import { useStopLossStatus } from "./useStopLossStatus";
import StopLossSelfServiceDocs from "./StopLossSelfServiceDocs";
import StopLossStatusCard from "./StopLossStatusCard";
import StopLossConfirmModal from "./StopLossConfirmModal";
import "./StopLossSelfService.scss";

const StopLossSelfService = () => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const queryClient = useQueryClient();
    const status = useStopLossStatus();

    const triggerMutation = useMutation({
        mutationFn: triggerStopLossReport,
        onSuccess: () => {
            setConfirmOpen(false);
            toast.success("Stop loss hold report started");
            queryClient.invalidateQueries({ queryKey: ["stoploss-status"] });
        },
        onError: (error) => {
            setConfirmOpen(false);
            toast.error(
                error?.cause?.error?.errorCode === "409"
                    ? "Already running — wait for it to finish before starting another."
                    : "Couldn't start the report. Try again."
            );
            queryClient.invalidateQueries({ queryKey: ["stoploss-status"] });
        },
    });

    return (
        <div className="container">
            <p className="title">Stop Loss HRP Hold Report Self-Service</p>
            <p className="sub-title">Run the daily Stop Loss HRP hold report off schedule</p>

            <StopLossSelfServiceDocs />

            <StopLossStatusCard
                isError={status.isError}
                isFetching={status.isFetching}
                state={status.state}
                failed={status.failed}
                inCooldown={status.inCooldown}
                disabled={status.disabled}
                cooldownRemainingMs={status.cooldownRemainingMs}
                data={status.data}
                onRetry={status.refetch}
                onTriggerClick={() => setConfirmOpen(true)}
            />

            <StopLossConfirmModal
                isOpen={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                isPending={triggerMutation.isPending}
                onConfirm={() => triggerMutation.mutate()}
            />
        </div>
    );
};

export default StopLossSelfService;
